<template>
  <div>
<!--     <div class="tb-list-item-meta">
      <div class="tb-list-item-meta-icon">
      </div>
      <div class="tb-list-item-meta-content">
        <h4 class="tb-list-item-meta-title">
          <Icon :type="genderIcon" />
          {{data.companyName}}
        </h4>
        <div class="tb-list-item-meta-description">
          <span>{{data.companyTypeText}} {{data.location}}</span>
        </div>
      </div>
    </div>
    <div class="tb-list-item-content">
      <div class="tb-list-item-content-item">
        <span>{{data.legalName}} {{data.companyPhone}}</span>
        <p>{{data.companyNatureText}} {{data.unionCreditCode}}</p>
      </div>
    </div> -->
    <div class="tb-list-item-cell">
      <div class="tb-list-item-cell-l">
        {{data.companyName}}（{{data.companyTypeText}} ）
      </div>
      <div class="tb-list-item-cell-r">
        <span style="margin-right: 5px;">{{data.legalName}}</span> <Icon type="md-call" />{{data.companyPhone}}
      </div>
    </div>
    <div class="tb-list-item-cell">
      <div class="tb-list-item-cell-l light">
        {{data.location}}
      </div>
      <div class="tb-list-item-cell-r" style="flex-basis: 60%;">
        <span>{{data.companyNatureText}}</span> <span title="统一信用代码">{{data.unionCreditCode}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    statusIcon() {
      return this.data.status == 0 ? 'success' : 'error'
    },
    genderIcon() {
      return this.data.gender == 0 ? 'ios-man' : 'ios-woman-outline'
    }
  },
  monuted() {
    console.log(this.$props)
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}

</script>
<style lang='scss' scoped>

.tb-list-item {
  display: flex;
  align-items: center;
  // padding: 12px 0;

  .focus {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    overflow: hidden;
  }

  .tb-list-item-meta {
    display: flex;
    flex: 1 1 60%;
    align-items: flex-start;
    font-size: 0;
    align-items: center;
  }

  .tb-list-item-meta-icon {
    font-size: 54px;
    line-height: 0;
    margin-right: 16px;
  }

  .tb-list-item-meta-title {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }

  .tb-list-item-meta-description {
    color: rgba(0, 0, 0, .45);
    font-size: 12px;
    line-height: 22px;
    span{display:block;}
  }

  .tb-list-item-content {
    display: flex;
    flex: 1 1 40%;
    justify-content: flex-end;
    color: rgba(0, 0, 0, .45);
    font-size: 12px;

    .tb-list-item-content-item {
      text-align: right;

      p {
        margin-top: 4px;
        margin-bottom: 0;
        line-height: 22px;
      }
    }

  }
}

</style>
